var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScheduleCallBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 7,
    fill: "#80D1F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2609 11.625L26.2174 11.59C26.0973 11.59 26 11.5008 26 11.38V9.96875C26 9.4855 25.6107 9 25.1304 9C24.6502 9 24.2609 9.4855 24.2609 9.96875V14C24.26 15 22.61 15 22.6087 14V12.0625C22.6087 11.8209 22.414 11.625 22.1739 11.625L16.9565 11.5938C16.8368 11.5938 16.7396 11.4963 16.7391 11.3759V9.84375C16.7391 9.3605 16.3498 9 15.8696 9C15.3893 9 15 9.3605 15 9.84375V14C15 15 13.5 15 13.4783 14V12.0625C13.4783 11.8209 13.2836 11.625 13.0435 11.625H11.7391C10.7786 11.625 10 12.4085 10 13.375V28.25C10 29.2165 10.7786 30 11.7391 30H28.2609C29.2214 30 30 29.2165 30 28.25V13.375C30 12.4085 29.2214 11.625 28.2609 11.625ZM27.5789 28H12.4211C12.1885 28 12 27.8106 12 27.5769V17.4231C12 17.1894 12.1885 17 12.4211 17H27.5789C27.8115 17 28 17.1894 28 17.4231V27.5769C28 27.8106 27.8115 28 27.5789 28Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleCallBadge);
export default __webpack_public_path__ + "static/media/schedule-call-badge.fde2630d.svg";
export { ForwardRef as ReactComponent };